import { Component, OnInit } from '@angular/core';
import { FormControlService } from './../../shared/services/form-control.service';
import { Textarea } from './../../models/editors/textarea.model';
import { ApiService } from './../../shared/services/api.service';
import { AlertService } from './../../shared/services/alert.service';
import { InlineFormBase } from './../../shared/components/base/inline-form/inline-form.base.component';

@Component({
  selector: 'swb-testimonial-settings',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})

export class TestimonialSettingsComponent extends InlineFormBase<any> implements OnInit {

  public url = 'testimonial-desc';

  public headerTitle = 'Text na přehledu referencí';
  public get fieldsConfig(): Array<any> {
    return [
      new Textarea({
        key: 'col_1',
        label: 'Sloupec 1',
        validators: [],
        isMultilang: true,
        wysiwyg: 'testimonial-col1'
      }),
      new Textarea({
        key: 'col_2',
        label: 'Sloupec 2',
        validators: [],
        isMultilang: true,
        wysiwyg: 'testimonial-col2'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }

}
